import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

export function RedirectPathToSwapOnly() {
  const location = useLocation()
  return <Navigate to={{ pathname: '/swap', search: location.search, hash: location.hash }} replace />
}
